'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SessionKey = exports.SessionKey = {
  Person: 'person',
  Workspaces: 'workspaces',
  SecretKey: 'secretKey'
};